module.exports = __webpack_public_path__ + "static/img/011.14bec06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/011.jpg
// module id = hcce
// module chunks = 0